<template>
    <transition name="fade" mode="out-in" appear>
        <v-main>
            <the-header-title :is-show-buttons="false" />
            <router-view />
        </v-main>
    </transition>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import TheHeaderTitle from '../organisms/layout/TheHeaderTitle.vue';
import TheLoginPage from '../pages/auth/TheLoginPage.vue';

@Component({
    components: {
        TheHeaderTitle,
        TheLoginPage,
    },
})
export default class TheLoginPageLayout extends Vue {}
</script>

<style lang="scss" scoped>
.fade-enter-active,
fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
